import { ApiError } from "./ApiError";
import config from "../config";

export class ApiService {
  constructor(baseURL = config.servicesHosts.infrastructureService) {
    this.baseURL = baseURL;
  }

  async request(endpoint, method = "GET", body = null, headers = {}, retry = true) {
    const token = localStorage.getItem("access_token");
    let finalUrl = `${this.baseURL}/${endpoint}`;
    const options = {
      method,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
        ...headers
      },
    };

    if (body) {
      if (["GET", "DELETE", "HEAD"].includes(method)) {
        const query = new URLSearchParams(body).toString();
        finalUrl += `?${query}`;
      } else {
        options.body = JSON.stringify(body);
      }
    }

    const response = await fetch(finalUrl, options);

    if(response.status === 503 && window.location.pathname !== "/error"){
      window.location.href = "/error";
    }
    
    if (response.status === 401 && retry) {
      const refreshed = await this.login(); 
      if (refreshed) {
        return this.request(endpoint, method, body, headers, false);
      }
    }   
    
    if (!response.ok) {
      let responseText = null;
      let result = null;
      try {
        responseText = await response.text();
        result = JSON.parse(responseText);
      } catch {
        result = null;
      }
  
      if (result?.errors) {
        const messages = Object.values(result.errors).flat();
        throw new ApiError(messages.join("\n"), response.status, result.errors);
      }
  
      if (result?.title || result?.detail) { 
        throw new ApiError(result.title || result.detail, response.status, result.errors);
      }
  
      if (result?.message) { 
        throw new ApiError(result.message, response.status);
      }
      
      if (responseText) {
        throw new ApiError(responseText, response.status);
      }

      throw new ApiError(`HTTP error! status: ${response.status}`, response.status);
    }

    if (response.status === 204) {
      return null;
    }

    const text = await response.text();
    return text ? JSON.parse(text) : null;
  }

  async login() {
    try {
      const refresh_token = localStorage.getItem("refresh_token");
      const response = await fetch(`${config.servicesHosts.authenticationService}/connect/token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          grant_type: "refresh_token",
          client_id: "spa",
          scope: "offline_access",
          refresh_token,
        }),
      });

      if (!response.ok) {
        console.log("Login failed", response.status);
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("user_role");        
        window.location.href = "/login";
        return false;
      }

      const data = await response.json();
      localStorage.setItem("access_token", data.access_token);
      localStorage.setItem("refresh_token", data.refresh_token);

      return true; 
    } catch (error) {
      console.log("Error fetching login: ", error);
      return false;
    }
  }

  get(endpoint, body, headers) {
    return this.request(endpoint, "GET", body, headers);
  }

  post(endpoint, body, headers) {
    return this.request(endpoint, "POST", body, headers);
  }

  put(endpoint, body, headers) {
    return this.request(endpoint, "PUT", body, headers);
  }

  patch(endpoint, body, headers) {
    return this.request(endpoint, "PATCH", body, headers);
  }

  delete(endpoint, body, headers) {
    return this.request(endpoint, "DELETE", body, headers);
  }
}
